import React, {useReducer} from 'react'


const initialState = {
    countOne: 0,
    countTwo : 0
};


// state c'est l'état actuel, action : c'est lélément qui donnera l'instruction au reducer pour donner le nouvel état 
// action est touché par la methode dispatch ligne 24
const reducer = (state, action ) =>{
    console.log(action);
// hyper important le commentaire
// console log de action donne : increment, décrement, reinitialiser
// log de state donne : state donne l'état actuel, c'est à dire l'état avant que j'incrémente/décré/réinit
    switch(action.type) {
        case 'increment':
            return {...state, countOne:  state.countOne + action.value} ;
        case  'decrement' :
            return {...state, countOne:  state.countOne - action.value}  ;
        case 'increment2':
            return {...state, countTwo:  state.countTwo + action.value} ;
        case  'decrement2' :
            return {...state, countTwo:  state.countTwo - action.value}  ;

        case  'reinitialiser' :
            return initialState ;

        default:
            return state
    }
}

const Count = () => {

   const [count, dispatch] = useReducer(reducer, initialState) // count et dispatch la variable et sa méthode, qu'elle valeur lui ai donné ? réducer

    return (
        <>
        <div className='row' >


            <div className='col-6'>

                <p className='h1'>{count.countOne}</p>

                <button className="btn btn-success m-3" onClick={
                    () => dispatch({type : 'increment', value : 1 })
                    }>+</button>

                <button className="btn btn-danger m-3" onClick={
                    () => dispatch({type : 'decrement', value : 1 })
                    }>-</button>

            </div>


            <div className='col-6'>

                <p className='h1'>{count.countTwo}</p>

                <button className="btn btn-success m-3" onClick={
                    () => dispatch({type : 'increment2', value : 10 })
                    }>+</button>

                <button className="btn btn-danger m-3" onClick={
                    () => dispatch({type : 'decrement2', value : 10 })
                    }>-</button>

            </div>


        </div>




                    <div className="col">
                        <button className="btn btn-primary m-3" onClick={
                            () => dispatch({type : 'reinitialiser'})
                            }>0
                        </button>
                    </div>
                

           
        
        </>
    )
}

export default Count
